import { createAction, handleActions } from 'redux-actions';

export const setSignupEmail = createAction('SET_SIGNUP_EMAIL');
export const setSignupPassword = createAction('SET_SIGNUP_PASSWORD');
export const setReset = createAction('SET_RESET');
export const setSignupDisplay = createAction('SET_SIGNUP_DISPLAY');
export const setSignupName = createAction('SET_SIGNUP_NAME');
export const setSignupMessage = createAction('SET_SIGNUP_MESSAGE');
export const setSignupTerms = createAction('SET_SIGNUP_TERMS');
export const setMobileWebView = createAction('SET_MOBILE_WEB_VIEW');
export const setQueryString = createAction('SET_QUERYSTRING');
export const checkEmail = createAction('CHECK_EMAIL');
export const resetQueryString = createAction('RESET_QUERYSTRING');

const initialState = {
	display: 'none',
	email: '',
	emailExists: false,
	errors: {},
	isMobileWebView: false,
	message: '',
	name: '',
	password: '',
	qs: {},
	terms: false
};

export default handleActions(
	{
		CHECK_EMAIL: (state, action) => ({ ...state, emailExists: action.payload }),
		RESET_QUERYSTRING: (state) => ({ ...state, qs: {} }),
		SET_MOBILE_WEB_VIEW: (state, action) => ({ ...state, isMobileWebView: action.payload }),
		SET_QUERYSTRING: (state, action) => ({ ...state, qs: action.payload }),
		SET_RESET: () => initialState,
		SET_SIGNUP_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SET_SIGNUP_EMAIL: (state, action) => ({ ...state, email: action.payload }),
		SET_SIGNUP_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_SIGNUP_NAME: (state, action) => ({
			...state,
			name: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_SIGNUP_PASSWORD: (state, action) => ({ ...state, password: action.payload }),
		SET_SIGNUP_TERMS: (state, action) => ({ ...state, terms: action.payload })
	},
	initialState
);
